import { SVGProps } from 'react';

export function ConversationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none" {...props}>
      <g clipPath="url(#clip0_2528_3557)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 3.36949C0.5 1.92278 1.67278 0.75 3.11949 0.75H15.693C17.1397 0.75 18.3125 1.92278 18.3125 3.36949V11.0533C18.3125 12.5 17.1397 13.6728 15.693 13.6728H10.0614C10.0126 13.6728 9.96609 13.6932 9.93303 13.729L6.19166 17.7821C5.78192 18.226 5.04044 17.9361 5.04044 17.332V13.8474C5.04044 13.751 4.96226 13.6728 4.86581 13.6728H3.11948C1.67278 13.6728 0.5 12.5 0.5 11.0533V3.36949ZM3.11949 1.79779C2.25146 1.79779 1.54779 2.50146 1.54779 3.36949V11.0533C1.54779 11.9213 2.25146 12.625 3.11948 12.625H4.86581C5.54094 12.625 6.08823 13.1723 6.08823 13.8474V16.3494L9.16311 13.0183C9.39452 12.7676 9.72017 12.625 10.0614 12.625H15.693C16.561 12.625 17.2647 11.9213 17.2647 11.0533V3.36949C17.2647 2.50146 16.561 1.79779 15.693 1.79779H3.11949Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2528_3557">
          <rect width="18" height="18" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
